// extracted by mini-css-extract-plugin
export default {"auth-form":"Login_auth-form__tgof8"};